import { PayTypes } from '@/modules/common/MutiPayChannel';
export interface IAgreement {
  title: string;
  color: string;
  content: string[];
}

export enum BottomType {
  APPLY = 'apply',
  ASSISTANT = 'assistant',
  SUBSCRIBE = 'subscribe',
  GUIDE = 'guide',
  FINISH = 'finish',
  COLLECT = 'collect',
}

export interface IBottom {
  type: BottomType;
  config: IApplyConfig | IBoughtConfig | null;
}
export interface IApplyConfig {
  show: false;
  origin_price: string;
  price: number;
  tag: string;
  tips: string;
  button: string;
  modal?: any;
  dead_time?: string; // 组合课底部倒计时
  coupon_image_url?: string; // 组合课红包弹窗配图
  document?: string; // 组合课底部倒计时文案
}

export interface IBoughtConfig {
  show: boolean;
  button: string;
  modal: IBottomConfig;
  config: IBottomConfig;
}

export interface UserList {
  avatar: string;
  nickname: string;
}

export interface Content {
  title: string;
  type: string;
  data: any;
}

export interface AppMessage {
  desc: string;
  imgUrl: string;
  link: string;
  title: string;
}

export interface Timeline {
  desc: string;
  imgUrl: string;
  link: string;
  title: string;
}

export interface Share {
  app_message: AppMessage;
  timeline: Timeline;
}

export interface SensorData {
  production_type: string;
  wx_app_name: string;
  actual_price: string;
}

export interface IPageConfig {
  strategy: string; // 截流策略版本
  mobile_check: boolean; // 是否开启强制验证手机号
  mobile_button_color: string; // 手机号验证模块btn主题色
  button_color: string; // 底部支付按钮色值(主题色)
  mobile: string; // 用户已验证的手机号
  agreement_check: boolean; // 协议勾选默认状态
  agreement_type: string; // 协议类型，用于/policy请求特定的协议内容
  payment_configs: PayTypes[]; // 支持的付款方式
  default_payment: PayTypes; // 默认的付款方式
  permission: boolean; // 是否有权限购买课程
  user_lists: UserList[]; // 购买了课程的用户列表
  header: any[]; // 报名页header内容，常用于顶部有动效部分
  content: Content[]; // 报名页主体内容
  share: Share; // 分享至朋友圈/好友的信息
  production_id: number; // 当前课程id
  sensor_data: SensorData; // 上报埋点信息
  is_limit?: boolean; //
  redirect_url?: string; // 重定向链接
  payment_check?: boolean;
}

export interface IUserData {
  bottom: IBottom;
  coupon_id: number;
  countDown: number;
}

export interface IBottomModal {
  is_feedback?: boolean;
  assistant_id?: number;
  guide: string[];
  qrcode: string;
}
export interface IBottomConfig {
  button: string;
  desc?: string;
  url?: string;
  survey?: string; // 问卷code
}

export interface IFreeChageRes {
  success: boolean;
}

export interface IUserInfo {
  InviterUserId: number;
  activity_class_id: number;
}
